import React, { useState } from 'react'
import { Box, Button, DropButton, Text, Anchor } from 'grommet'
import { Menu, User, Logout, FormDown, Search } from 'grommet-icons'
import { Link, useLocation } from "react-router-dom"
import EnvSelect from './EnvSelect'

import SearchForm from '../shortcut/Search'

const AppBar = ({ toggleSidebar, handleClickSidebar, handleLogout, envSelected, handleEnvSelect }) => {

    const [showSiteList, setShowSiteList] = useState(false)

    const handleClickSiteButton = () => {
        setShowSiteList(!showSiteList)
    }

    const [showSearch, setShowSearch] = useState(false)
    // const [showInbox, setShowInbox] = useState(false)
    // const [myMessages, setMyMessages] = useState([])

    const siteMapping = {
        "control-lite.trade.tt": "Lite",
        "control.trade.tt": "Prod(Auto)",
        "control-us.trade.tt": "Prod(US)",
        "control-eu.trade.tt": "Prod(EU)",
        
        "control-uat.trade.tt": "UAT(Auto)",
        "control-uat-us.trade.tt": "UAT(US)",
        "control-uat-eu.trade.tt": "UAT(EU)",
        
        "control-int.debesys.net": "Internal(Auto)",
        "control-int-us.debesys.net": "Internal(US)",
        "control-int-eu.debesys.net": "Internal(EU)",
    }

    const handleClickSearch = () => {
        setShowSearch(!showSearch)
    }

    // const handleClickInbox = () => {
    //     setShowInbox(!showInbox)
    // }

    let location = useLocation();

    return (
        <>
            {/* <Notifications /> */}
            {showSearch && <SearchForm />}
            {/* {showInbox && <MyInbox />} */}
            <Box
                tag='header'
                direction='row'
                align='center'
                justify='start'
                background="brand"
                pad={{ left: 'none', right: 'none', vertical: 'none' }}
                gap='none'
                elevation='small'
                style={{ zIndex: '1' }}
                border={{ size: "small", side: "bottom", color: "white" }}
            >
                <Box
                    basis="3/4"
                    gap='none'
                    pad='none'
                    direction='row'
                    align='center'
                    justify='start'
                >
                    <Button hoverIndicator={{ color: "light-1", opacity: "weak" }} icon={<Menu color="white" />} onClick={toggleSidebar} />
                    <Box
                        gap='none'
                        pad='none'
                        direction='row'
                        align='start'
                    >
                        <EnvSelect envSelected={envSelected} handleEnvSelect={handleEnvSelect} />
                    </Box>
                </Box>

                <Box
                    basis="1/4"
                    gap='none'
                    pad='none'
                    direction='row'
                    align='center'
                    justify='end'
                    margin={{ right: 'xxsmall' }}
                >
                    <DropButton
                        name="env_drop"
                        open={showSiteList}
                        onOpen={() => handleClickSiteButton()}
                        onClose={() => handleClickSiteButton()}
                        dropContent={<DropContent onClose={() => handleClickSiteButton()} />}
                        hoverIndicator={{ color: "light-1", opacity: "weak" }}
                        dropProps={{ align: { top: "bottom", right: "right" } }}
                        dropAlign={{ top: 'bottom', right: 'right' }}
                    >
                        <Box direction="row" gap="xsmall" align="center" pad="small">
                            <Text size="16px">
                                {siteMapping[window.location.hostname] ? siteMapping[window.location.hostname] : "localhost"}
                            </Text>
                            {!process.env.REACT_APP_ENVIRONMENT.includes("local") && 
                                <FormDown color="white" />
                            }
                        </Box>
                    </DropButton>

                    <Link to={{pathname:"/user", search:location.search}}>
                        <Button 
                            hoverIndicator={{ color: "light-1", opacity: "weak" }} 
                            icon={<User color="white" size="medium" />} 
                            onClick={handleClickSidebar} 
                        />
                    </Link>

                    <Button
                        hoverIndicator={{ color: "light-1", opacity: "weak" }}
                        icon={<Search color="white" size="medium" />}
                        onClick={handleClickSearch}
                    />

                    <Button 
                        hoverIndicator={{ color: "light-1", opacity: "weak" }} 
                        icon={<Logout color="white" size="medium" />} 
                        onClick={handleLogout} 
                    />
                </Box>
            </Box >
        </>
    )
}

const DropLink = ({ site, url }) => (
    <Box background="light-2" pad="xsmall">
        <Anchor href={"https://" + url} target="_blank">
            <Button fill plain
                label={<Text margin="small" color="brand" size="15px">{site}</Text>}
                hoverIndicator={{ color: "brand", opacity: "weak" }} />
        </Anchor>
    </Box>
)

const UAT_ENVIRONMENTS = ["ext-uat", "ext-uat-us", "ext-uat-eu"]
const PROD_ENVIRONMENTS = ["ext-prod", "ext-prod-us", "ext-prod-eu"]
const INT_ENVIRONMENTS = ["int-dev", "int-dev-us", "int-dev-eu"]

const DropContent = ({ onClose }) => {
    if (PROD_ENVIRONMENTS.includes(process.env.REACT_APP_ENVIRONMENT) || UAT_ENVIRONMENTS.includes(process.env.REACT_APP_ENVIRONMENT)) {
        return (
            <Box background="light-2">
                <DropLink site="Prod(Auto)" url="control.trade.tt" />
                <DropLink site="Prod(US)" url="control-us.trade.tt" />
                <DropLink site="Prod(EU)" url="control-us.trade.tt" />
                <DropLink site="UAT(Auto)" url="control-uat.trade.tt" />
                <DropLink site="UAT(US)" url="control-uat-us.trade.tt" />
                <DropLink site="UAT(EU)" url="control-uat-eu.trade.tt" />
            </Box>
        )
    } else if (process.env.REACT_APP_ENVIRONMENT === "ext-lite" || INT_ENVIRONMENTS.includes(process.env.REACT_APP_ENVIRONMENT))
    {
        return (
            <Box background="light-2">
                <DropLink site="Lite" url="control-lite.trade.tt" />
                <DropLink site="Internal(Auto)" url="control-int.debesys.net" />
                <DropLink site="Internal(US)" url="control-int-us.debesys.net" />
                <DropLink site="Internal(EU)" url="control-int-eu.debesys.net" />
            </Box>
        )
    } else {
        return null
    }
}

export default AppBar